export const editor = {
  block_format: {
    bulleted_list: 'Bulleted List',
    check_list: 'Check List',
    code_block: 'Code Block',
    heading_1: 'Heading 1',
    heading_2: 'Heading 2',
    heading_3: 'Heading 3',
    numbered_list: 'Numbered List',
    paragraph: 'Paragraph',
    quote: 'Quote',
  },
  block_insert: {
    horizontal_rule: 'Horizontal Rule',
    image: 'Image',
    insert: 'Insert',
    table: 'Table',
  },
  cancel: 'Cancel',
  characters: 'characters',
  clear_editor: 'Clear Editor',
  clear_editor_description: 'Are you sure you want to clear the editor?',
  clear_formatting: 'Clear Formatting',
  edit_mode: {
    edit_mode: 'Edit Mode',
    lock: 'Lock',
    read_only_mode: 'Read Only Mode',
    unlock: 'Unlock',
    view_only_mode: 'View Only Mode',
  },
  element_format: {
    'Center Align': 'Center Align',
    'Justify Align': 'Justify Align',
    'Left Align': 'Left Align',
    'Right Align': 'Right Align',
    indent: 'Indent',
    outdent: 'Outdent',
  },
  font_color: {
    background_color: 'Background Color',
    text_color: 'Text Color',
  },
  font_format: {
    bold: 'Bold',
    italic: 'Italic',
    strikethrough: 'Strikethrough',
    underline: 'Underline',
  },
  history: {
    redo_apple: 'Redo (⇧⌘Z)',
    redo_windows: 'Redo (Ctrl+Y)',
    undo_apple: 'Undo (⌘Z)',
    undo_windows: 'Undo (Ctrl+Z)',
  },
  image: {
    add_alt_text: 'Add alt text',
    alt_text: 'Alt Text',
    alt_text_description:
      'Describes the image for screen readers and search engines. Leave it empty only if the image is decorative.',
    alt_text_placeholder: 'Descriptive alternative text',
    alt_text_title: 'Image alt text',
    confirm: 'Confirm',
    image: 'Image',
    image_url: 'Image URL',
    image_url_placeholder: 'i.e. https://source.unsplash.com/random',
    insert_image: 'Insert Image',
  },
  link: {
    toggle_link: 'Toggle Link',
    url_placeholder: 'https://example.com',
  },
  placeholder: 'Press «/» for commands...',
  subsuper: {
    subscript: 'Subscript',
    superscript: 'Superscript',
  },
  table: {
    confirm: 'Confirm',
    insert_table: 'Insert Table',
    number_of_columns: 'Number of Columns',
    number_of_columns_placeholder: 'Number of Columns (1-50)',
    number_of_rows: 'Number of Rows',
    number_of_rows_placeholder: 'Number of Rows (1-500)',
    table: 'Table',
  },
  media_hub: {
    title: 'Add Image',
    tabs: {
      stock: 'Stock Photos',
      ai: 'AI Generate',
      url: 'URL',
    },
    stock: {
      search_placeholder: 'Search photos...',
      no_results: 'No images found for "{{query}}"',
      api_error: 'Could not load images. Try again.',
      retry: 'Retry',
      powered_by: 'Powered by Magnific',
    },
    ai: {
      section_label: 'Section context',
      section_placeholder: 'Select a section',
      section_none: 'General (no specific section)',
      prompt_label: 'Describe the image',
      prompt_placeholder: 'A professional photo of...',
      generate: 'Generate',
      regenerate: 'Regenerate',
      accept: 'Use this image',
      generating: 'Generating...',
      recent_title: 'Recent',
      no_content_context: 'Save the content first to generate AI images.',
    },
    alt_text_label: 'Alt text',
    alt_text_placeholder: 'Describe this image for accessibility',
    insert: 'Insert Image',
    inserting: 'Inserting...',
    download_error: 'Failed to download image. Please try again.',
  },
  ai_edit: {
    placeholder: 'Ask AI to edit...',
    editing: 'Editing...',
    accept: 'Accept',
    revert: 'Revert',
    cancel: 'Cancel',
  },
  ai_full_edit: {
    placeholder: 'Iterate...',
    iterating: 'Iterating on content...',
    review: 'Review the changes',
    accept: 'Accept',
    reject: 'Reject',
    cancel: 'Cancel',
    diff: 'Diff',
    cursor_label: 'AI',
  },
  words: 'words',
} as const
